// extracted by mini-css-extract-plugin
export default {"deleteIcon":"rmTqxLPqqvL0JBS_KOja"};